<template>
	<div class="checkbox-wrapper">
		<v-checkbox
			v-bind="$props"
			hide-details
			v-on="$listeners"
		/>
		<div
			v-if="explainer"
			class="checkbox-explainer"
		>
			{{ explainer }}
		</div>
	</div>
</template>

<script>
import { VCheckbox } from 'vuetify/lib'

export default {
	name: 'checkbox',
	extends: VCheckbox,
	props: {
		explainer: {
			type: String,
			default: null
		}
	}
}
</script>

<style lang="scss">
	.checkbox-wrapper {
		width: 100%;
	}

	.checkbox-explainer {
		font-size: 0.75rem;
		font-family: 'Inter', sans-serif;
		color: var(--global-muted-foreground);
		margin-top: 4px;
		line-height: 1.4;
		margin-left: 32px; /* Align with checkbox label */
	}
</style>
